import Vue from "vue";
import Component from "vue-class-component";
import { DgGridContainer, DgText } from "@dasgate/uikit";
import { Prop } from "vue-property-decorator";

@Component({ components: { DgText, DgGridContainer } })
export default class VisitListHeader extends Vue {
  @Prop({ required: false, default: false }) public isReceptionist!: boolean;
}
